import {TemplateComponent} from './template-component';
import {Template} from './template';
import {TemplateDeliveryPath} from './template-delivery-path';

export class TemplateDefinition {

  constructor(
    public id: number,
    public template: Template,
    public templateComponent: TemplateComponent,
    public deliveryPath: TemplateDeliveryPath,
    public displaySequence: number
  ) {}

}
